var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCoilShortLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 114,
    viewBox: "0 0 80 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 80,
    height: 106,
    rx: 4,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 61.4443,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8453 73.333H52.2453V59.533C52.2453 56.133 52.2453 48.733 41.9953 48.733C38.1953 48.733 34.4453 49.883 31.7953 52.583L34.9453 55.733C36.5453 54.233 38.8453 53.233 41.3453 53.233C44.5453 53.233 46.8453 54.783 46.8453 57.733V58.383H45.3453C39.3453 58.383 30.2453 58.933 30.2453 66.733C30.2453 71.483 34.5453 73.933 38.9953 73.933C42.1953 73.933 44.9953 72.733 46.6953 70.033H46.8453V73.333ZM46.4953 63.933C46.4953 67.283 44.5453 69.433 40.4453 69.433C38.4953 69.433 36.2453 68.483 36.2453 66.283C36.2453 62.833 41.9453 62.583 45.2453 62.583H46.4953V63.933Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.834,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 70.834 14.1113)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.834,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 60.834 14.1113)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.834,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 50.834 14.1113)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.834,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 40.834 14.1113)",
    fill: "#52B3A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.834,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 30.834 14.1113)",
    fill: "#52B3A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.834,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 20.834 14.1113)",
    fill: "#52B3A7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.834,
    y: 14.1113,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 10.834 14.1113)",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCoilShortLeft);
export default __webpack_public_path__ + "static/media/jobconfig-binding-coil-short-left.3430d050b249f99793b7b082c746c61d.svg";
export { ForwardRef as ReactComponent };